// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"navigationitem_NavigationItem__2daRt","active":"navigationitem_active__124P9"};